/**
 * Composant navigation par onglets pour l'administration
 * @module admin/components/AdminTabs
 */

import React from 'react';
import PropTypes from 'prop-types';
import { TabLabels, ALL_TABS } from '../constants/tabConfig';

/**
 * Composant navigation par onglets
 * @param {Object} props
 * @param {string} props.activeTab - Onglet actif
 * @param {function} props.onTabChange - Fonction appelée lors du changement d'onglet
 * @returns {JSX.Element}
 */
const AdminTabs = ({ activeTab, onTabChange }) => {
  return (
    <nav className="admin-tabs">
      {ALL_TABS.map((tabKey) => (
        <button
          key={tabKey}
          type="button"
          className={`admin-tab-button ${activeTab === tabKey ? 'active' : ''}`}
          onClick={() => onTabChange(tabKey)}
          aria-current={activeTab === tabKey ? 'page' : undefined}
        >
          {TabLabels[tabKey]}
        </button>
      ))}
    </nav>
  );
};

AdminTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default AdminTabs;
